import React from 'react';
import { cn } from '../../lib/utils'; // Assuming a standard cn utility, but we'll inline it if needed. Wait, I should provide a simple utility or just use template literals.
// Simple inline class merger since we don't have clsx/tailwind-merge setup guaranteed
const cx = (...classes: (string | undefined | null | false)[]) => classes.filter(Boolean).join(' ');
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'full';
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-sans font-bold uppercase tracking-wider transition-colors rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-gold text-white hover:bg-gold-hover',
    secondary: 'bg-sage text-white hover:bg-sage/90',
    outline: 'border border-gold text-gold hover:bg-gold hover:text-white',
    ghost: 'hover:bg-muted text-foreground'
  };
  const sizes = {
    sm: 'h-10 px-4 text-xs',
    md: 'h-12 px-8 text-sm',
    lg: 'h-14 px-10 text-sm',
    full: 'h-14 w-full px-8 text-sm md:w-auto' // Full width on mobile, auto on md+
  };
  return <button className={cx(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-150" />;
}